export default {
    distributor: JSON.parse(localStorage.getItem('distributor'))
};
